<template>
  <div>

  </div>
</template>

<script>
import config from '@/config'
export default {
  name: 'Land',
  props: {
    activityId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  methods: {
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      console.log(userAgentInfo)
      var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
      }
      return flag;
    }
  },
  mounted() {
    let activityId = localStorage.getItem('activityId')
    const that = this
    if (this.IsPC()) {
      if (config && config.client && config.client.web && config.client.web.baseUrl && window.location.href.indexOf(config.client.web.baseUrl) < 0 ) {
        // window.location.replace(`${config.client.web.baseUrl}land/${this.activityId}`)
          window.location.replace(`${config.client.web.baseUrl}land`)
        return
      }
    } else {
      if (config && config.client && config.client.h5 && config.client.h5.baseUrl && window.location.href.indexOf(config.client.h5.baseUrl) < 0) {
        // window.location.replace(`${config.client.h5.baseUrl}land/${this.activityId}`)
        window.location.replace(`${config.client.h5.baseUrl}land`)
        return
      }
    }
    if (!activityId) {
      // this.$store.dispatch('activity/setId', this.activityId)
      //   .then(function () {
      //     that.$router.replace({name: 'login'})
      //   })
      this.$router.replace({name: 'login'})
    } else {
      this.$router.replace({name: 'list'})
    }
  }
}
</script>
